module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_34.fbaca222.png";